import spPriorityTemplate from './sppriority.html';
import { format } from 'date-fns';

angular
   .module('org.saga.widget.sppriority', [
      'org.saga.service',
      'org.saga.newsppriority',
      'org.saga.spprioritycomment'
   ])
   .directive('sppriorityWidget', [
      'PropertiesLoader',
      '$translate',
      'InstanceExpression',
      'SpPriorities',
      'SpComments',
      function (PropertiesLoader, $translate, InstanceExpression, SpPriorities, SpComments) {
         return {
            restrict: 'E',
            require: '^form',
            controllerAs: 'ctrl',
            template: spPriorityTemplate,
            scope: {
               widget: '=',
               editable: '=',
               instance: '=',
               required: '=',
               output: '=?',
               lastcommentid: '=?'
            },
            controller: [
               '$scope',
               '$parse',
               '$mdDialog',
               'DefaultProperties',
               'NewSpPriorityDialog',
               'SpPriorityCommentDialog',
               function (
                  $scope,
                  $parse,
                  $mdDialog,
                  DefaultProperties,
                  NewSpPriorityDialog,
                  SpPriorityCommentDialog
               ) {
                  PropertiesLoader.load($scope, DefaultProperties.sppriority);
                  $scope.loading = false;

                  function getValueFromAttribute(attribute) {
                     return InstanceExpression.eval(attribute, $scope.instance);
                  }

                  $scope.processId = getValueFromAttribute($scope.processId);
                  $scope.socialPartnerId = getValueFromAttribute($scope.socialPartnerId);
                  $scope.commentCreatorEmail = getValueFromAttribute($scope.commentCreatorEmail);
                  $scope.commentCreatorName = getValueFromAttribute($scope.commentCreatorName);
                  $scope.commentCreatorDepartment = getValueFromAttribute(
                     $scope.commentCreatorDepartment
                  );

                  function getPriorities() {
                     $scope.loading = true;
                     SpPriorities.fetch({
                        processId: $scope.processId,
                        socialPartnerId: $scope.socialPartnerId
                     })
                        .$promise.then(function (response) {
                           $scope.loading = false;
                           $scope.output = angular.copy(response.results);
                           $scope.reloadKey = Date.now(); // Force re-render of ng-repeat
                        })
                        .catch(function () {
                           $scope.loading = false;
                           $scope.output = [];
                        });
                  }

                  getPriorities();

                  $scope.showAddPriorityDialog = function () {
                     NewSpPriorityDialog.show(
                        {
                           processId: $scope.processId,
                           socialPartnerId: $scope.socialPartnerId
                        },
                        (priority) => $scope.formatAndSave(priority)
                     );
                  };

                  $scope.deletePriority = function (priorityId) {
                     SpPriorities.delete({ row_id: priorityId })
                        .$promise.then(function () {
                           getPriorities();
                        })
                        .catch(function (error) {
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title($translate.instant('SpPriorityDeleteErrorTitle'))
                                 .textContent(
                                    $translate.instant('SpPriorityDeleteErrorMessage') +
                                       '\n' +
                                       error.data.message
                                 )
                                 .ok($translate.instant('Ok'))
                           );
                        });
                  };

                  function createUploadData(priority) {
                     return {
                        processId: priority.processId,
                        priorityName: priority.priorityName,
                        priorityGoal: priority.priorityGoal,
                        priorityDescription: priority.priorityDescription,
                        socialPartnerId: priority.socialPartnerId
                     };
                  }

                  $scope.editPriority = function (priority) {
                     const priorityToEdit = angular.copy(priority);

                     NewSpPriorityDialog.show(priorityToEdit, (newPriority) => {
                        const data = createUploadData(newPriority);
                        SpPriorities.update({ row_id: newPriority.id }, data)
                           .$promise.then(function () {
                              getPriorities();
                           })
                           .catch(function (error) {
                              $mdDialog.show(
                                 $mdDialog
                                    .alert()
                                    .clickOutsideToClose(true)
                                    .title($translate.instant('SpPrioritySaveErrorTitle'))
                                    .textContent(
                                       $translate.instant('SpPrioritySaveErrorMessage') +
                                          '\n' +
                                          error.data.message
                                    )
                                    .ok($translate.instant('Ok'))
                              );
                           });
                     });
                  };

                  $scope.duplicatePriority = function (priorityToDuplicate) {
                     const newPriority = angular.copy({
                        priorityName: priorityToDuplicate.priorityName,
                        priorityGoal: priorityToDuplicate.priorityGoal,
                        priorityDescription: priorityToDuplicate.priorityDescription,
                        processId: priorityToDuplicate.processId,
                        socialPartnerId: priorityToDuplicate.socialPartnerId
                     });

                     NewSpPriorityDialog.show(newPriority, (priority) =>
                        $scope.formatAndSave(priority)
                     );
                  };

                  $scope.formatAndSave = function (priority) {
                     const data = createUploadData(priority);

                     SpPriorities.create(data)
                        .$promise.then(function () {
                           getPriorities();
                        })
                        .catch(function (error) {
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title($translate.instant('SpPrioritySaveErrorTitle'))
                                 .textContent(
                                    $translate.instant('SpPrioritySaveErrorMessage') +
                                       '\n' +
                                       error.data.message
                                 )
                                 .ok($translate.instant('Ok'))
                           );
                        });
                  };

                  $scope.orderDown = function (itemId, index) {
                     let rowId, moveBeforeRowId;

                     //check if the item is the last one or penultimate
                     if (index + 2 >= $scope.output.length) {
                        //move last item before current item instead
                        rowId = $scope.output[index + 1].id;
                        moveBeforeRowId = itemId;
                     } else {
                        rowId = itemId;
                        moveBeforeRowId = $scope.output[index + 2].id;
                     }

                     reorderPriorities(rowId, moveBeforeRowId);
                  };

                  $scope.orderUp = function (itemId, index) {
                     const moveBeforeRowId = $scope.output[index - 1].id;

                     reorderPriorities(itemId, moveBeforeRowId);
                  };

                  function reorderPriorities(rowId, moveBeforeRowId) {
                     SpPriorities.reorder({ row_id: rowId, moveBeforeRowId: moveBeforeRowId })
                        .$promise.then(function () {
                           getPriorities();
                        })
                        .catch(function (error) {
                           $mdDialog.show(
                              $mdDialog
                                 .alert()
                                 .clickOutsideToClose(true)
                                 .title($translate.instant('SpPrioritySaveErrorTitle'))
                                 .textContent(
                                    $translate.instant('SpPrioritySaveErrorMessage') +
                                       '\n' +
                                       error.data.message
                                 )
                                 .ok($translate.instant('Ok'))
                           );
                        });
                  }

                  function getNewComment(priority) {
                     return {
                        commentSeverity: null,
                        commentDescription: null,
                        commentSettlementDecision: null,
                        commentObjectType: 'PRIORITY',
                        commentObjectId: priority.priorityId,
                        commentCreatorEmail: $scope.commentCreatorEmail,
                        commentCreatorName: $scope.commentCreatorName,
                        commentCreatorDepartment: $scope.commentCreatorDepartment,
                        commentResolverEmail: null,
                        commentResolverName: null,
                        resolverNote: null,
                        commentType: $scope.configuration,
                        processId: $scope.processId,
                        socialPartnerId: $scope.socialPartnerId,
                        linkToPriority: priority.priorityId,
                     };
                  }

                  $scope.addComment = function (priority) {
                     if (
                        !$scope.commentCreatorEmail ||
                        !$scope.commentCreatorName ||
                        !$scope.commentCreatorDepartment
                     ) {
                        console.log('Missing comment creator info, cannot add comment');
                        return;
                     }

                     const comment = getNewComment(priority);
                     SpPriorityCommentDialog.show(
                        priority,
                        comment,
                        $scope.configuration,
                        (comment) => {
                           SpComments.create(comment)
                              .$promise.then(function (response) {
                                 $scope.lastcommentid = response.commentId;
                              })
                              .catch(function (error) {
                                 $mdDialog.show(
                                    $mdDialog
                                       .alert()
                                       .clickOutsideToClose(true)
                                       .title('Chyba')
                                       .textContent(
                                          'Nepodařilo se uložit výzvu/připomínku' +
                                             '\n' +
                                             error.data.message
                                       )
                                       .ok($translate.instant('Ok'))
                                 );
                              });
                        }
                     );
                  };
               }
            ]
         };
      }
   ]);
